import React from 'react';
import styles from './ChannelList.module.css';

function ChannelList({ channels, activeChannel, onChannelClick }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Channels</h3>
      </div>

      <div className={styles.channelList}>
        {channels.map((channel) => (
          <div
            key={channel.id}
            className={`${styles.channelItem} ${
              activeChannel?.id === channel.id ? styles.active : ''
            }`}
            onClick={() => onChannelClick(channel)}
          >
            <span className={styles.channelName}>#{channel.name}</span>
            {!channel.is_writable && (
              <span className={styles.readOnlyBadge}>RO</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ChannelList;
